






import Vue from 'vue';
import Component from 'vue-class-component';

import { AxiosError } from 'axios';

import { helpers, debug } from 'RootDir/core/mixins/helpers';

@Component
export default class App extends Vue {
  // currentUser!: Administration.CurrentUser;

  errorCatcher: number | null = null;

  // checkAuthorization() {
  //   setTimeout(() => {
  //     const currentPath = this.$router.currentRoute.path;
  //     if (
  //       !this.$store.getters['auth/isAuthenticated']
  //       && this.$store.getters['auth/token'] === null
  //       && currentPath !== '/auth/login'
  //       && currentPath !== '/auth/reset-password'
  //     ) {
  //       this.$router.push({ name: 'login' });
  //     }
  //   }, 200);
  // }

  catchAllTheErrors() {
    this.errorCatcher = this.$http.interceptors.response.use(
      (response) => response,
      (error: AxiosError) => {
        this.$debug('Error');
        const currentPath = this.$router.currentRoute.path;
        if (typeof error.response === 'undefined') {
          const message = 'Ошибка соединения с сервером!';
          this.$s.notify.error(message, { timeout: 2000 });
          return Promise.reject(error);
        }
        // 401 Unauthorized («не авторизован (не представился)»)
        if (error.response.status === 401) {
          // eslint-disable-next-line no-console
          // console.log(error.isAxiosError, error.config, error.response);
          let message = 'Ошибка авторизации, пожалуйста, авторизуйтесь заново!';
          if (currentPath === '/auth/login') {
            message = 'Неправильный логин пользователя или пароль!';
          }
          this.$s.notify.error(message, { timeout: 3000 });

          this.$store.dispatch('user/removeUser');
          this.$store.dispatch('auth/logout');
          if (currentPath !== '/auth/login') {
            this.$router.push({ name: 'login' });
          }

          // return Promise.reject(error);
        }
        // 403 Forbidden («запрещено (не уполномочен)»)
        if (error.response.status === 403) {
          const message = 'Доступ с данной ролью запрещен!';
          this.$s.notify.error(message, { timeout: 2000 });
          // return Promise.reject(error);
        }
        // 404 Not Found («не найдено»)
        if (error.response.status === 404) {
          const message = 'Запрашиваемый объект не найден!';
          this.$s.notify.error(message, { timeout: 2000 });
          // return Promise.reject(error);
        }
        // 429 Too Many Requests («слишком много запросов»)
        if (error.response.status === 429) {
          const message = error.response.data?.detail ?? 'Превышено допустимое количество запросов. Пожалуйста, повторите через минуту!';
          this.$s.notify.error(message, { timeout: 2000 });
          // return Promise.reject(error);
        }
        if (error.response.status === 422) {
          this.$debug({ ...error });
          error.response.data.errors.forEach((e) => {
            const customFieldName = e.ctx?.field_name;
            let { msg } = e;
            if (customFieldName) {
              msg = `${customFieldName} - ${msg}`;
            }
            this.$s.notify.error(msg);
          });
        }

        return Promise.reject(error);
      },
    );
  }

  mounted() {
    // this.checkAuthorization();
    this.catchAllTheErrors();
    Vue.prototype.$s = helpers(this.$store, this.$q);
    Vue.prototype.$debug = debug;
  }

  beforeDestroy() {
    if (this.errorCatcher !== null) {
      this.$http.interceptors.response.eject(this.errorCatcher);
    }
  }
}
